module.exports = __webpack_public_path__ + "img/9788965641971.d972c51c.jpg";